function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke-width:4.2px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Rechteck_369",
  fill: "none",
  d: "M0 0H28V28H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_1191",
  transform: "translate(-126.601 -739.409)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_47",
  d: "M-1.268 0c0-5.872-4.477-10.634-10-10.634s-10 4.762-10 10.634",
  className: "cls-2",
  transform: "translate(151.869 766.617)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_48",
  d: "M.177.308a4 4 0 0 0 4-4 4 4 0 0 0-4-4 4 4 0 0 0-4 4 4 4 0 0 0 4 4z",
  className: "cls-2",
  transform: "translate(140.423 750.101)"
}));

function SvgMenuKontakt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "menu_kontakt",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuKontakt);
export default __webpack_public_path__ + "static/media/menu_kontakt.9f061e29.svg";
export { ForwardRef as ReactComponent };